import { render, staticRenderFns } from "./AzFileUpload.vue?vue&type=template&id=23d3058f&"
import script from "./AzFileUpload.vue?vue&type=script&lang=js&"
export * from "./AzFileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports